module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td>Общие сведения о происхождении</td>\n			<td><control type=\"text\" target=\"item.statement\"/></td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Технологии создания набора данных</div>\n				<div class=\"lineage-processsteps\"></div>\n				<div class=\"buttons\"><button on-click=\"addProcessStep\">Добавить</button></div>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\">\n				<div class=\"title\">Источники данных</div>\n				<div class=\"lineage-sources\"></div>\n				<div class=\"buttons\"><button on-click=\"addSource\">Добавить</button></div>\n			</td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}